import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERIES_KEYS } from 'constant';
import useRefreshQueue from 'features/queue/newGrid/hooks/useRefreshQueue';
import {
  getBulkActionsFields,
  deleteTicketsByIds,
  changeFieldValuesByIds,
  archiveTickets,
  getTicketsPermissions,
} from 'services/bulkActionsService';

export const useGetBulkActionsFieldsQuery = () =>
  useQuery(['bulkActionsFields'], () => getBulkActionsFields(), { placeholderData: [] });

export function useDeleteTicketsByIdsQuery() {
  const deleteTicketsMutation = useMutation(deleteTicketsByIds);

  const deleteTickets = async (ticketIds) => {
    const data = await deleteTicketsMutation.mutateAsync(ticketIds);
    return data;
  };

  return {
    deleteTickets,
    ...deleteTicketsMutation,
  };
}

export function useUpdateTicketsByIdsQuery() {
  const changeFieldTicketsMutation = useMutation(changeFieldValuesByIds);

  const changeFieldValues = async (ticketIds) => {
    const data = await changeFieldTicketsMutation.mutateAsync(ticketIds);
    return data;
  };

  return {
    changeFieldValues,
    ...changeFieldTicketsMutation,
  };
}

export function useArchiveTickets() {
  const queryClient = useQueryClient();
  const refreshQueue = useRefreshQueue();

  const { mutateAsync } = useMutation({
    mutationFn: archiveTickets,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [QUERIES_KEYS.QUEUE_DATA] });
      (variables?.payload?.archiveSrIDs || []).forEach((srId) =>
        queryClient.invalidateQueries({ queryKey: ['srId', String(srId)] }),
      );

      refreshQueue({ clearCache: false, showLoader: false });
    },
  });

  return { archiveTickets: mutateAsync };
}

export function useGetTicketsPermissions() {
  const { mutateAsync } = useMutation({
    mutationFn: getTicketsPermissions,
  });

  return { getTicketsPermissions: mutateAsync };
}
